import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPostRequestFile
} from "@/helper/requests"

const state = {
  userAgreements: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getUserAgreements: state => state.userAgreements.items,
  getUserAgreementsCount: state => state.userAgreements.count,
  getUserAgreementsCurrentUrl: state => state.userAgreements.currentUrl,
  getUserAgreementsNext: state => state.userAgreements.next,
  getUserAgreementsPrev: state => state.userAgreements.prev,
  getUserAgreementsDetail: state => state.userAgreements.detail,
  isLoadingUserAgreements: state => state.userAgreements.loading,
  saveUserAgreementsError: state => state.userAgreements.error,
}

const actions = {
  loadUserAgreements: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.MEMBER.AGREEMENTS.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingUserAgreements) {
      commit('SET_USER_AGREEMENTS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_USER_AGREEMENTS', data.results)
          commit('SET_USER_AGREEMENTS_COUNT', data.count)
          commit('SET_USER_AGREEMENTS_CURRENT_URL', url)
          commit('SET_USER_AGREEMENTS_NEXT_URL', data.next)
          commit('SET_USER_AGREEMENTS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_USER_AGREEMENTS_LOADING_END')
          commit('SAVE_USER_AGREEMENTS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  createUserAgreements: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.AGREEMENTS.CREATE()
    commit('SET_USER_AGREEMENTS_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_USER_AGREEMENTS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_USER_AGREEMENTS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  updateUserAgreements: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.AGREEMENTS.UPDATE()
    commit('SET_USER_AGREEMENTS_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_USER_AGREEMENTS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_USER_AGREEMENTS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  // loadUserAgreementsDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
  //   if (!url) url = url = mendeleev.USER.USER_AGREEMENTS.USER_AGREEMENTS.DETAIL(id)
  //   sendGetRequest(
  //     url, (data, url) => {
  //       commit('SET_USER_AGREEMENTS_DETAIL', data);
  //       finalizer(data, url);
  //     }, (data, url) => {
  //       commit('SAVE_USER_AGREEMENTS_ERROR', data);
  //       catcher(data, url);
  //     }
  //   )
  // },
}

const mutations = {
  SET_USER_AGREEMENTS: (state, value) => {
    state.userAgreements.items = value
  },
  SET_USER_AGREEMENTS_DETAIL: (state, value) => {
    state.userAgreements.detail = value
  },
  SET_USER_AGREEMENTS_COUNT: (state, value) => {
    state.userAgreements.count = value
  },
  SET_USER_AGREEMENTS_CURRENT_URL: (state, value) => {
    state.userAgreements.currentUrl = value
  },
  SET_USER_AGREEMENTS_NEXT_URL: (state, value) => {
    state.userAgreements.next = value
  },
  SET_USER_AGREEMENTS_PREV_URL: (state, value) => {
    state.userAgreements.prev = value
  },
  SET_USER_AGREEMENTS_LOADING: (state) => {
    state.userAgreements.loading = true
  },
  SET_USER_AGREEMENTS_LOADING_END: (state) => {
    state.userAgreements.loading = false
  },
  SAVE_USER_AGREEMENTS_ERROR: (state, error) => {
    state.userAgreements.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
